import { defineComponent as c, createElementBlock as m, openBlock as d, createVNode as n, unref as e } from "vue";
import { RevButtonIcon as a } from "@ds/components/ButtonIcon";
import p from "../../../icons/generated/IconChevronLeft.vue2.js";
import f from "../../../icons/generated/IconChevronRight.vue2.js";
import { useI18n as u } from "@ds/plugin";
import i from "../../../translations/generic.translations.js";
const v = { class: "hidden gap-12 md:flex" }, N = /* @__PURE__ */ c({
  __name: "CardCarouselController",
  props: {
    prevAlternativeText: {},
    nextAlternativeText: {},
    canScrollPrev: { type: Boolean, default: !1 },
    canScrollNext: { type: Boolean, default: !1 }
  },
  emits: ["scroll"],
  setup(x, { emit: s }) {
    const t = s, o = u();
    return (l, r) => (d(), m("div", v, [
      n(e(a), {
        "alternative-text": e(o)(e(i).cardCarouselControllerPrevious),
        disabled: !l.canScrollPrev,
        icon: e(p),
        variant: "primary",
        onClick: r[0] || (r[0] = () => t("scroll", "backward"))
      }, null, 8, ["alternative-text", "disabled", "icon"]),
      n(e(a), {
        "alternative-text": e(o)(e(i).cardCarouselControllerNext),
        disabled: !l.canScrollNext,
        icon: e(f),
        variant: "primary",
        onClick: r[1] || (r[1] = () => t("scroll", "forward"))
      }, null, 8, ["alternative-text", "disabled", "icon"])
    ]));
  }
});
export {
  N as default
};
